import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { CyberAttackTypeEnum } from 'src/app/model/alerts/attacks/cyber-attack-type-enum';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-block-ip',
  templateUrl: './block-ip.component.html',
  styleUrl: './block-ip.component.scss',
})
export class BlockIpComponent {
  public working: boolean = false;
  public form: FormGroup;

  public cyberAttackTypesEnum = Object.values(CyberAttackTypeEnum);

  constructor(
    public dialogRef: MatDialogRef<Component>,
    private fb: FormBuilder,
    private alertService: AlertService,
    private toastService: ToastrService,
  ) {
    this.form = this.fb.group({
      type: ['', Validators.required],
      ip: ['', Validators.required],
    });
  }

  saveClicked() {
    if (this.form.valid) {
      this.working = true;
      let value = this.form.value;
      this.alertService
        .createManualAlert(value.ip, value.type)
        .then(() => {
          this.toastService.success('Ip or domain blocked successfully');
        })
        .catch((er) => {
          this.toastService.error(er);
        })
        .finally(() => {
          this.working = false;
          this.dialogRef.close(true);
        });
    }
  }

  cancelClicked() {
    this.dialogRef.close(false);
  }
}
